import { qsa } from 'modules/dom';

function findInputForName(form, name) {
  const pattern = new RegExp(`\\[${name}\\](?|$)`);
  return qsa('input, select, textarea', form).find((field) => pattern.test(field.name || ''));
}

function removeAllErrors(form) {
  qsa('.form-group', form).forEach((group) => {
    group.classList.remove('has-error');
    qsa('.help-block', group).forEach((block) => block.remove());
  });
}

function applyErrors(form, errors) {
  Object.entries(errors).forEach(([key, messages]) => {
    const input = findInputForName(form, key);
    if (!input) return;

    const group = input.closest('.form-group');
    if (!group) return;

    group.classList.add('has-error');
    const help = document.createElement('span');
    help.className = 'help-block';
    help.textContent = messages.join(', ');
    group.appendChild(help);
  });
}

export function renderBootstrapErrors(form, errors) {
  if (!form || !errors) return;
  removeAllErrors(form);
  applyErrors(form, errors);
}

globalThis.renderBootstrapErrors = renderBootstrapErrors;
